var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.baslik))]),_c('div',{staticClass:"paragraph"},[_vm._v(_vm._s(_vm.altBaslik))])])
}
var staticRenderFns = []

export { render, staticRenderFns }